import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { Card, Alert } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getWithdrawalcount } from "../../redux/actions/getWithdrawalCountAction";
import { updateLoadCount } from "../../redux/actions/updateLoadCountAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SaveIcon from "@mui/icons-material/Save";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AddLoadCount() {
	const [withdrawAllowed, setWithdrawAllowed] = useState("");
	const classes = useStyles();
	const dispatch = useDispatch();

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [updateLoadCountStatus, setUpdateLoadCountStatus] =
		React.useState(false);
	const [updateLoadCountResArray, setUpdateLoadCountResArray] = useState("");

	const handleChange = ({ target: { name, value } }) => {
		if (name === "WithdrawAllowed") {
			//setWithdrawAllowed(value);
			Util.verifyAmount(value)
				? setWithdrawAllowed(value)
				: setWithdrawAllowed(withdrawAllowed);
		}
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const getWithdrawalcountRes = useSelector(
		({ getWithdrawalCount }) => getWithdrawalCount
	);

	const updateLoadCountRes = useSelector(
		({ updateLoadCount }) => updateLoadCount
	);

	// console.log("updateLoadCountRes", updateLoadCountRes);

	const updateLoadCountFunc = () => {
		setUpdateLoadCountStatus(true);
		const updateLoadCountReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			numberOfLoadAllowed: withdrawAllowed
		};
		return dispatch(updateLoadCount(updateLoadCountReq, authToken));
	};

	const getWithdrawalcountFunc = () => {
		dispatch(
			getWithdrawalcount(
				{
					loginDetails: {
						walletOwnerId: regenerateTokenRes.data.partnerId || ""
					}
				},
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWithdrawalcountFunc();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (updateLoadCountStatus) {
			updateLoadCountResFun();
		}
	}, [updateLoadCountRes.data.status]);

	useEffect(() => {
		setWithdrawAllowed(getWithdrawalcountRes.data.numberOfLoadAllowed);
	}, [getWithdrawalcountRes.data]);

	const updateLoadCountResFun = () => {
		if (updateLoadCountStatus) {
			if (updateLoadCountRes.data.status == "success") {
				setUpdateLoadCountResArray(updateLoadCountRes.data);
				setNotificationOpen(true);
			}
			if (
				updateLoadCountRes.data.status == "failed" ||
				updateLoadCountRes.data.status == "Failed"
			) {
				setUpdateLoadCountResArray(updateLoadCountRes.data);
				setNotificationOpen(true);
				if (
					updateLoadCountRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateLoadCountRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={1}
						style={{
							padding: "8px",
							marginTop: "1rem",
							marginBottom: "1rem",
							justifyContent: "center"
						}}
					>
						<Grid
							className="mx-4"
							item
							sm={12}
							md={5}
							lg={5}
							style={{ width: "100%" }}
						>
							<TextField
								required
								size="small"
								color="primary"
								variant="standard"
								autoFocus={true}
								type="text"
								label="Number of Load Allowed"
								fullWidth={true}
								name="WithdrawAllowed"
								value={withdrawAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item sm={12} md={2} lg={2}>
							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "7px",
                }}
                variant="contained"
                className="riskRuleButton"
                onClick={updateLoadCountFunc}
                endIcon={<SaveIcon />}
              >
                Save
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={updateLoadCountFunc}
								// endIcon={<SaveIcon />}
							>
								Save <SaveIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
			</Layout>

			{updateLoadCountResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateLoadCountResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateLoadCountResArray.status == "failed" ||
				(updateLoadCountResArray.status == "Failed" && (
					<div>
						<Dialog open={notificationOpen} onClose={handleNoticationClose}>
							<DialogContent
								className="text-center"
								style={{ backgroundColor: "#00b9f51c" }}
							>
								<img src={failed} alt="" width="100px" className="my-2" />
							</DialogContent>
							<DialogContent>
								<h4
									style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
								>
									{updateLoadCountResArray.description}
								</h4>
							</DialogContent>
							<DialogActions style={{ justifyContent: "center" }}>
								{/* <Button
									style={{
										margin: "10px 0",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={handleNoticationClose}
								>
									Ok
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={handleNoticationClose}
									// endIcon={<SaveIcon />}
								>
									Ok
								</CustomButton>
							</DialogActions>
						</Dialog>
					</div>
				))}
		</>
	);
}

export default AddLoadCount;
